const namespace = "topic";

export const topic = `${namespace}_category_list`;
export const topic_select = `${namespace}_category_select`;
